import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { PageHeader } from 'components';

import installation from './Installation';
import troubleShooting from './TroubleShooting';
import msConfig from './MSConfig';

function Installer() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Installer" goBack={() => navigate('/hardware')} />
      <div className="jumbotron">
        <p>
          Installer App is the last application you would ever need to install
          in order to integrate any Erply hardware device. The app runs in the
          background on your computer. Once configured and started you do not
          have to do anything else. The app will download, start, stop, update
          and remove any micro-service that you would ever need.
        </p>
      </div>
      <Row>
        <Col sm={12} md={4}>
          <Link to={`${location.pathname}/installation`}>
            <Button variant="link">Installation</Button>
          </Link>
        </Col>
        <Col sm={12} md={4}>
          <Link to={`${location.pathname}/troubleshooting`}>
            <Button variant="link">Troubleshooting</Button>
          </Link>
        </Col>
        <Col sm={12} md={4}>
          <Link to={`${location.pathname}/msconfig`}>
            <Button variant="link">Micro-service management</Button>
          </Link>
        </Col>
      </Row>
    </div>
  );
}

const subRoutes = [installation, troubleShooting, msConfig];

export default {
  linkName: 'Installer App',
  path: '/hardware/installer',
  component: Installer,
  subRoutes,
  rootPath: { name: 'Hardware', uri: '/hardware' },
  subPath: [{ name: 'Installer' }],
};
